import axios from 'axios';
import logger from './ClientLogger';
import store from '../store';
import StravaAuth from './StravaAuth';

class StravaApi {

    public async getLoggedInAthleteActivities(start: Date, end: Date, page: number, perPage: number = 30) {
        const requestedEnd = +end > +Date.now() ? Date.now() : end;
        const url = await this.getUrl('/athlete/activities',
            { before: +requestedEnd / 1000, after: +start / 1000, page, per_page: perPage });
        const response = await axios.get(url);
        return response.data;
    }

    // public enum StreamType
    // {
    //     Time,
    //     LatLng,
    //     Distance,
    //     Altitude,
    //     VelocitySmooth,
    //     Heartrate,
    //     Cadence,
    //     Watts,
    //     Temperature,
    //     Moving,
    //     GradeSmooth
    // }

    public async getActivityStreams(id: number): Promise<any[]> {
        return this.getStreams('activities', ['Time', 'LatLng', 'Altitude'], id);
    }

    public async getSegmentStreams(id: number) {
        return this.getStreams('segments', ['Time', 'LatLng', 'Altitude'], id);
    }

    public async getSegmentEffortStreams(id: number) {
        return this.getStreams('segment_efforts', ['Time', 'LatLng', 'Altitude'], id);
    }

    public async getRouteStreams(id: number) {
        return this.getStreams('routes', ['Time', 'LatLng', 'Altitude'], id);
    }

    public async getActivity(id: number) {
        const url = await this.getUrl(`/activities/${id}`, {});
        const response = await axios.get(url);
        return response.data;
    }

    public async getSegment(id: number) {
        const url = await this.getUrl(`/segments/${id}`, {});
        const response = await axios.get(url);
        return response.data;
    }

    private async getStreams(type: string, data: string[], id: number): Promise<any[]> {
        const d = data.map((str) => str.toLowerCase()).join(',');
        const url = await this.getUrl(`/${type}/${id}/streams/${d}`, {});
        const response = await axios.get(url);
        return response.data ? this.joinStreams(response.data) : [];
    }

    private async getUrl(uri, opts): Promise<string> {
        await this.ensureValidToken();
        const auth = { access_token: store.state.token };
        const query = this.objectToKeyValues(opts).concat(this.objectToKeyValues(auth)).join('&');
        return `https://www.strava.com/api/v3${uri}?${query}`;
    }

    private calcTokenState() {
        let tokenState = 'noToken';
        let secondsUntilExpiry = -1;
        const s = store.state;
        if (s.auth && s.auth.accessToken) {
            secondsUntilExpiry = (s.auth.expiresAt - (new Date().getTime() / 1000));
            if (secondsUntilExpiry < 0) {
                tokenState = 'expired';
            } else if (secondsUntilExpiry < (30 * 60)) {
                tokenState = 'expiring';
            } else {
                tokenState = 'valid';
            }
        }
        return { state: tokenState, expirySeconds: secondsUntilExpiry };
    }

    private async ensureValidToken() {
        const tokenState = this.calcTokenState();
      //  logger.debug(`TOKEN-STATE={state=${tokenState.state},expires=${Math.trunc(tokenState.expirySeconds)}s}`);
        switch (tokenState.state) {
            // case 'expired':
            //     if (store.state.code) {
            //         logger.debug(`TOKEN-STATE - attempt token exchange with code`);
            //         const data = await new StravaAuth().tokenExchangeAsync(store.state.code);
            //         store.commit('refreshToken', data.auth);
            //     } else {
            //         logger.log('requesting new token');
            //         new StravaAuth().navigateOAuth();
            //     }
            //     break;
            case 'expired':
            case 'expiring':
      //          logger.debug(`TOKEN-STATE - attempt refresh token`);
                const refreshAuth = await new StravaAuth().tokenRefresh(store.state.auth.refreshToken);
                logger.log(`new token [${refreshAuth.accessToken}]`);
                store.commit('refreshToken', refreshAuth);
                break;
        }
    }

    private joinStreams(streams: any[]): any[] {
        const data = [];
        const points = Array.from(new Set(streams.map((s) => s.data ? s.data.length : 0)));
        // check if there are the same number of points in each stream
        if (points.length === 1) {
            for (let i = 0; i < points[0]; i++) {
                const point = { lat: 0, lng: 0 };
                streams.forEach((e) => {
                    switch (e.type) {
                        case 'latlng':
                            point.lat = e.data[i][0];
                            point.lng = e.data[i][1];
                            break;
                        default:
                            point[e.type] = e.data[i];
                            break;
                    }
                });
                data.push(point);
            }
        }
        return data;
    }

    private objectToKeyValues(obj) {
        return Object.getOwnPropertyNames(obj).map((n) => `${n}=${obj[n]}`);
    }

}

const stravaApi = new StravaApi();

export default stravaApi;
